<template>
  <div class="row mt-4">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="col-6">
      <div class="row">
        <div class="col-6">
          <b-form-group
              label="Tipo de Postal:"
              label-align="left"
              class="mginInputTrt"
              id="fieldset-1"
          >
            <b-form-select v-model="postal.tipo" :options="tipos"></b-form-select>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group
              label="Área Corporativa	:"
              label-align="left"
              class="mginInputTrt"
              id="fieldset-2"
          >
            <b-form-select v-model="postal.areaId" :options="areas"></b-form-select>
          </b-form-group>
        </div>
      </div>
      <b-form-group
          label="Link:"
          label-align="left"
          class="mginInputTrt"
          id="fieldset-3"
      >
        <b-form-input v-model="postal.link" type="url" class="mb-3"></b-form-input>
      </b-form-group>
      <b-form-group
          label="Postal:"
          label-align="left"
          class="mginInputTrt"
          id="fieldset-4"
      >
        <div class="row">
          <div class="col-6">
            <b-form-file
                class="mt-3"
                plain
                accept=".jpg, .png, .gif, .jpeg"
                @change="selectFile"
            ></b-form-file>
          </div>
          <div class="col-6">
            <b-button
                variant="primary"
                :disabled="
        postal.tipo == null ||
        postal.areaId == null ||
        postal.link == null ||
        file == null ||
        btnDisabled === true
      "
                @click="crearPostal"
            >Guardar
            </b-button
            >
          </div>
        </div>

      </b-form-group>
    </div>
    <div class="col-6 p-3">
      <div class="row">
        <div class="col-6">
          <template v-if="img !== null">
            <img :src="img" class="img-fluid mb-5 imagen" alt="">
          </template>
        </div>
        <div class="col-6">
          <template v-if="postal.link !== ''">
            <link-prevue cardWidth="100%" :url="postal.link"></link-prevue>
          </template>
        </div>
      </div>


    </div>
    <br/>


    <br/>
    <br/>
  </div>
</template>

<script>
import miniToastr from "mini-toastr"; //ES6
import LinkPrevue from 'link-prevue'

export default {
  name: "altaPostal",
  props: {
    msg: String,
  },
  components: {
    LinkPrevue
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    btnDisabled: false,
    postal: {
      tipo: null,
      areaId: null,
      link: null,
    },
    tipos: [
      {value: null, text: "Selecciona una opción", disabled: true},
      {value: 1, text: "Anuncio"},
      {value: 2, text: "Cumpleaños"},
    ],
    areas: [],
    file: null,
    img: null,
  }),

  methods: {
    selectFile(e) {
      let files = e.target.files || e.dataTransfer.files;

      const file = new Blob([files[0]], {type: "image/png"});

      this.file = file;

      let reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = (evt) => {
        let img = new Image();
        img.onload = () => {
          if (img.width > 850 || img.height > 350) {
            this.file = null;

            this.$swal({
              icon: "error",
              title: "La imagen excede del tamaño 850px x 350px",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        };
        img.src = evt.target.result;
        this.img = evt.target.result;
      };

      reader.onerror = (evt) => {
        console.error(evt);
      };
    },
    crearPostal() {
      let config = {
        header: {
          "Content-Type": "image/png",
        },
      };

      const formData = new FormData();
      formData.append("archivoDTO",this.file, this.file.filename);
      formData.append("tipo",this.postal.tipo);
      formData.append("areaId",this.postal.areaId);
      formData.append("link", this.postal.link);
      formData.append("idUsuario",this.$localStorageService.getIdUsuario());

      this.$swal
          .fire({
            title: "¿Estás seguro de crear la postal?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {

              this.btnDisabled = true;
              this.$http
                  .post(
                      this.$api +
                      "postal/crear",
                      formData,
                      config

                  )
                  .then((response) => {
                    if (response.status === 200) {
                      var message = response.data.message
                          ? response.data.message
                          : "Se guardo correctamente el registro";
                      miniToastr.success(message);
                    }
                  })
                  .catch((error) => {
                    var message = error.response.data.message
                        ? error.response.data.message
                        : "Error al crear el registro";
                    miniToastr.info(message);
                    this.btnDisabled = false;
                  })
                  .finally(() => {
                    this.btnDisabled = false;
                    location.reload();
                  });
              //   pendiente
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          })
          .then((result) => {
            if (result.value) {
              this.$swal({
                icon: "success",
                title: "Se registro correctamente",
                showConfirmButton: false,
                timer: 2500,
              });
            }
          })
    },
    obtenerAreas() {
      this.$http
          .get(this.$api + "catalogos/listaAreas")
          .then((response) => {
            if (response.status === 200) {
              this.areas = response.data.data.map(function (itm) {
                itm.value = itm.idArea;
                itm.text = itm.nombreArea;
                return itm;
              });

              this.areas.push({
                value: null,
                text: "Selecciona una opción",
                disabled: true,
              });

            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerAreas();
  },
};
</script>

<style scoped>
.mginInputTrt {
  padding: 10px;
  font-weight: bolder !important;
}

.imagen {
  border: #DDD solid;
}

.txtLeft {
  font-weight: bolder;
  text-align: left;
  margin-left: 10px;
}

.paddingDiv {
  padding: 10px;
}
</style>
